export default __webpack_public_path__ + "static/media/About_csi_w.1c3eeebd.svg";